var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParques(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Parques",
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.871,
    height: 152.174,
    viewBox: "0 0 151.871 152.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #418c5a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M261.2,51.6a25.093,25.093,0,0,0-29.626-31.37,28.475,28.475,0,1,0-51.3,23.5,2.972,2.972,0,0,0,5-3.186A22.54,22.54,0,1,1,226.5,24.475a2.972,2.972,0,0,0,3.95,2.265,19.146,19.146,0,0,1,24.371,25.194,2.972,2.972,0,0,0,1.513,3.819,22.609,22.609,0,0,1,13.193,20.507,24.412,24.412,0,0,1-1.962,9.213,23.114,23.114,0,0,1-2.749,4.571,2.972,2.972,0,0,0,4.633,3.706,29.068,29.068,0,0,0,3.567-5.92,30.2,30.2,0,0,0,2.437-11.57A28.561,28.561,0,0,0,261.2,51.6Z",
    transform: "translate(-123.583 0.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M346.919,199.009V159.953h2.743a2.972,2.972,0,1,0,0-5.944H334.846a27.524,27.524,0,0,0-19.592,8.114l-7.76,7.76v-26.9l8.551-8.539a2.972,2.972,0,0,0-4.2-4.2l-4.354,4.345V117.732a2.972,2.972,0,0,0-5.944,0v59.325a2.972,2.972,0,0,0,5.052,2.1l12.825-12.822a21.755,21.755,0,0,1,2.954-2.473v35.174a8.9,8.9,0,0,0,.636,17.773H346.77a8.9,8.9,0,1,0,.149-17.8ZM328.337,160.94a21.846,21.846,0,0,1,6.509-.987h6.14v39.053H328.337Zm18.427,49.931H323.038a2.972,2.972,0,1,1,0-5.944H346.77a2.972,2.972,0,0,1,0,5.944Z",
    transform: "translate(-211.928 -80.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M20.467,223.978a2.972,2.972,0,0,0-4.084,1l-.033.053a2.972,2.972,0,0,0,5.076,3.07l.033-.053A2.972,2.972,0,0,0,20.467,223.978Z",
    transform: "translate(-11.254 -157.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M113.859,226.878H95.569V193.294l10.173-10.173a2.972,2.972,0,1,0-4.2-4.194L90.5,189.968a2.972,2.972,0,0,0-.868,2.1v34.812H85.3V169.642a2.972,2.972,0,0,0-1.31-2.464L75.2,161.264a23.655,23.655,0,0,0-.5-3.489h7.632A2.972,2.972,0,0,0,85.3,154.8V117.732a2.972,2.972,0,1,0-5.944,0v34.11H72.521a23.815,23.815,0,0,0-18.828-12.625A16.447,16.447,0,1,0,21.52,134.37a16.644,16.644,0,0,0,.229,2.755,24.667,24.667,0,0,0-6.631,2.235,2.972,2.972,0,0,0,2.675,5.3,18.75,18.75,0,0,1,7.888-2,2.972,2.972,0,0,0,2.627-4.137,10.515,10.515,0,1,1,18.2,1.991,2.972,2.972,0,0,0,2.767,4.678,17.794,17.794,0,0,1,20.044,17.7h0a17.684,17.684,0,0,1-5.528,12.9,2.972,2.972,0,0,0-.386,3.84,14.814,14.814,0,1,1-24.237,17.039v-5.62l7.5-7.5,7.133,3.908a2.972,2.972,0,1,0,2.844-5.2l-5.623-3.076,2.886-2.886a2.972,2.972,0,0,0-4.194-4.2l-5.647,5.647h0l-4.9,4.9V156.886a2.972,2.972,0,0,0-5.944,0V168.21L23.8,158.782a2.972,2.972,0,1,0-4.2,4.2l13.309,13.309a3.057,3.057,0,0,0,.318.27v13.255h0v5.528c-.018.03-.042.056-.056.086a14.53,14.53,0,1,1-22.139-18.1,2.972,2.972,0,0,0,.4-4.093,18.7,18.7,0,0,1-4.051-11.686,2.972,2.972,0,0,0-5.944,0,24.564,24.564,0,0,0,3.789,13.172,20.457,20.457,0,0,0,28,29.64v22.519H18.988a2.972,2.972,0,1,0,0,5.944h94.871a2.972,2.972,0,1,0,0-5.944Zm-34.5,0h-40.2V204.95A20.745,20.745,0,0,0,69.549,178.33a23.459,23.459,0,0,0,5.139-10.254l4.669,3.144Z",
    transform: "translate(-0.003 -80.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M230.494,37.232a17.422,17.422,0,0,0-17.4,17.4,2.972,2.972,0,1,0,5.944,0A11.481,11.481,0,0,1,230.5,43.164a2.972,2.972,0,1,0,0-5.944Z",
    transform: "translate(-149.759 -26.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M374.912,106.46a2.972,2.972,0,0,0,0,5.944,7.133,7.133,0,0,1,7.133,7.133,2.972,2.972,0,1,0,5.944,0A13.077,13.077,0,0,0,374.912,106.46Z",
    transform: "translate(-261.398 -74.816)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParques);
export default __webpack_public_path__ + "static/media/Parques.d7345be59e2f79049c62dcaafd3a34a3.svg";
export { ForwardRef as ReactComponent };